import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Input, Table, TableBody, TableCell, TableHead, TableRow, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LoginIcon from "@mui/icons-material/Login";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AllEmployee() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }
    const getRefLink = (code) => {
        const host = window.location.hostname;
        let baseDomain = host;
        if (host.includes("localhost") || host.includes("127.0.0.1")) {
            baseDomain = "localhost:3000";
        } else {
            baseDomain = host.replace(/^(admin\.|cms\.|agency\.|ag\.)/, "");
        }
        return `${window.location.protocol}//${baseDomain}/register?code=${code}`;
    };
    const handleCopyLink = (text) => {
        const tempInput = document.createElement("input");
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        swal("Thành công", "Copy link giới thiệu thành công!", "success");
    };
    const [users, setUser] = useState(null);
    const [nhanvien, setNhanvien] = useState(null);
    const [load, setLoad] = useState(false);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [searched, setSearched] = useState("");
    const [type, setType] = useState("customer");
    const [data2, setData2] = useState(null);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [editData, setEditData] = useState({ name: "", sdt: "", password: "", paypwd: "" });

    const handleUpdateUser = async (e) => {
        e.preventDefault();
        try {
            if(editData.name !== editUser.name || editData.sdt !== editUser.sdt) {
                await axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${editUser._id}`, { id: editUser._id, name: editData.name, sdt: editData.sdt });
            }
            if(editData.password) {
                await axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, { id: editUser._id, password: editData.password });
            }
            if(editData.paypwd) {
                await axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, { id: editUser._id, paypwd: editData.paypwd });
            }
            swal("Thành công", "Đã cập nhật thông tin đại lý", "success");
            setOpenEditModal(false);
            setLoad(false);
        } catch (err) {
            swal("Lỗi", "Có lỗi xảy ra khi cập nhật", "error");
        }
    };
    const navigate = useNavigate();
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        if (load == false) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {})
                .then((res) => {
                    if (res.data.data) setData2(res.data.data);
                    setUser(res.data.data);
                    setLoad(true);
                })
                .then((res) => setLoad(true));
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {params: {keyword:"nhanvien"}})
                .then((res) => {
                    setNhanvien(res.data.data);
                    setLoad(true);
                })
                .then((res) => setLoad(true));
        }
    }, [load]);
    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);

        if (searchedVal !== "") {
            const filteredRows = data2.filter((row) => {
                const a = row?.username.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const b = Number(row.iduser).toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                return a || b;
            });
            setUser(filteredRows);
        } else {
            setUser(data2);
        }
    };
    const handleChange = (e) => {
        setType(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            username: e.target.username.value,
            password: e.target.password.value,
            name: e.target.name.value,
            sdt: e.target.sdt.value,
            type: "customer"
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/createEmployee`, formData)
            .then((res) => {
                setLoad(false);
                setOpenAddModal(false);
                swal("Thành công", "Thêm đại lý thành công", "success");
            })
            .catch((err) => {
                swal("Lỗi", err.response?.data?.message || "Có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    const handleEditHoahong = (item) => {
        swal({
            title: "Cập nhật hoa hồng",
            text: `Nhập phần trăm hoa hồng mới cho đại lý ${item.username}:`,
            content: {
                element: "input",
                attributes: {
                    placeholder: "Ví dụ: 0.2",
                    type: "number",
                    defaultValue: item.hoahong
                }
            },
            buttons: ["Hủy", "Lưu"],
        }).then((val) => {
            if (val !== null && val !== "") {
                axios.put(`${process.env.REACT_APP_API_URL}/auth/updateHoahong/${item._id}`, { hoahong: Number(val) })
                    .then(res => {
                        if (res.data.success) {
                            swal("Thành công", "Đã cập nhật hoa hồng!", "success");
                            setLoad(false); // reload list
                        } else {
                            swal("Lỗi", res.data.message || "Cập nhật thất bại", "error");
                        }
                    })
                    .catch(() => swal("Lỗi", "Có lỗi xảy ra", "error"));
            }
        });
    };

    const handleLoginAgency = (item) => {
        axios.post(`${process.env.REACT_APP_API_URL}/auth/loginAsAgency/${item._id}`)
            .then(res => {
                if (res.data.success) {
                    const host = window.location.hostname;
                    let baseDomain = host;
                    if (host.includes("localhost") || host.includes("127.0.0.1")) {
                        baseDomain = "localhost:3000";
                    } else {
                        baseDomain = host.replace(/^(admin\.|cms\.|agency\.|ag\.)/, "");
                    }
                    const protocol = (host.includes("localhost") || host.includes("127.0.0.1")) ? "http:" : "https:";
                    const agencyUrl = `${protocol}//agency.${baseDomain}/?token=${res.data.token}`;
                    window.open(agencyUrl, "_blank");
                } else {
                    swal("Lỗi", res.data.message, "error");
                }
            })
            .catch(() => swal("Lỗi", "Không thể đăng nhập đại lý", "error"));
    };
    const handleSubmitLs = (e) => {
        e.preventDefault();
        const formData = {
            id: ls._id,
            permission: {
                full: Number(e.target.full.value),
                set: Number(e.target.full.value) == 1 ? 1 : Number(e.target.set.value),
                money: Number(e.target.full.value) == 1 ? 1 : Number(e.target.money.value),
                edit: Number(e.target.full.value) == 1 ? 1 : Number(e.target.edit.value),
            }
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/permission`, formData)
            .then((res) => {
                setShow(false);
                swal(t('success'), "", "success").then((value) => {
                    window.location.reload();
                });
            })
            .catch((err) => {
                setShow(false);
                swal(t('error'), "", "error");
            });
    };
    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        <Container maxWidth={false}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, mt: 2 }}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>Danh sách đại lý</div>
                                <Button variant="contained" color="error" onClick={() => setOpenAddModal(true)}>
                                    Thêm đại lý
                                </Button>
                            </Box>
                            <div className="form_set">
                                <Box>
                                    {/*<TextField
                                        value={searched}
                                        onChange={(searchVal) => requestSearch(searchVal.target.value)}
                                        placeholder={t('search')}
                                        
                                    />*/}
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>Tên đại lý</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Tên đăng nhập</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Số điện thoại</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Mã mời</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Hoa hồng (%)</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Trạng thái</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Ngày tạo</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Tác vụ</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {users &&
                                                users.map((item) => (
                                                    <>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.name || 'Chưa cập nhật'}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.username}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.sdt || 'Chưa cập nhật'}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                {item.code}
                                                                <div style={{ marginTop: "4px", fontSize: "11px" }}>
                                                                    <span 
                                                                        onClick={() => {
                                                                            const link = getRefLink(item.code);
                                                                            handleCopyLink(link);
                                                                        }} 
                                                                        style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontWeight: "normal" }}
                                                                    >
                                                                        Copy Link
                                                                    </span>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", color: "green", display: "flex", alignItems: "center" }}>
                                                                {item.hoahong}%
                                                                <IconButton size="small" color="primary" onClick={() => handleEditHoahong(item)} sx={{ ml: 1 }}>
                                                                    <EditIcon fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                {item.isLock ? (
                                                                    <span style={{ color: "red", border: "1px solid red", padding: "2px 5px", borderRadius: "4px", fontSize: "12px" }}>Bị khóa</span>
                                                                ) : (
                                                                    <span style={{ color: "green", border: "1px solid green", padding: "2px 5px", borderRadius: "4px", fontSize: "12px" }}>Đã duyệt</span>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item.createdAt))}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", display: "flex", gap: "10px" }}>
                                                                <Button 
                                                                    variant="contained"
                                                                    color="info"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setEditUser(item);
                                                                        setEditData({ name: item.name || "", sdt: item.sdt || "", password: "", paypwd: "" });
                                                                        setOpenEditModal(true);
                                                                    }}>
                                                                    Sửa
                                                                </Button>
                                                                <Button 
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => navigate(`/admin/employee/${item.code}`)}>
                                                                    DS Khách
                                                                </Button>
                                                                <Button 
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    size="small"
                                                                    startIcon={<LoginIcon />}
                                                                    onClick={() => handleLoginAgency(item)}>
                                                                    Login
                                                                </Button>
                                                                {item.isLock == false ? (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="error"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            axios
                                                                                .post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, {
                                                                                    id: item._id,
                                                                                    isLock: true
                                                                                })
                                                                                .then((res) => {
                                                                                    setLoad(false);
                                                                                    swal(t("lock") + " " + t("success"), "", "success");
                                                                                });
                                                                        }}>
                                                                        Khóa
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="success"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            axios
                                                                                .post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, {
                                                                                    id: item._id,
                                                                                    isLock: false
                                                                                })
                                                                                .then((res) => {
                                                                                    setLoad(false);
                                                                                    swal(t("unlock") + " " + t("success"), "", "success");
                                                                                });
                                                                        }}>
                                                                        Mở khóa
                                                                    </Button>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </div>
                        </Container>
                    </Box>
                    {isShow === true ? (
                        <>
                            <div className="modal">
                                <div className="modaloverlay">
                                    <i className="ti-close closelogin"></i>
                                </div>
                                <div className="modalbody">
                                    <form onSubmit={handleSubmitLs}>
                                        <div className="modalinner">
                                            <div className="modalheader"> {t("permission")} </div>

                                            <div className="modalform">
                                                <div className="modalformgroup d-flex" style={{ padding: "9px" }}>
                                                    <div>{t("username")}: </div>
                                                    <div>
                                                        <b>{ls?.username}</b>
                                                    </div>
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div style={{ color: "red" }}>{t("full_permission")}</div>
                                                    <TextField name="full" defaultValue={ls?.permission?.full} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("permission_1")}</div>
                                                    <TextField name="money" defaultValue={ls?.permission?.money} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("permission_2")}</div>
                                                    <TextField name="set" defaultValue={ls?.permission?.set} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("permission_3")}</div>
                                                    <TextField name="edit" defaultValue={ls?.permission?.edit} sx={{ width: "100%" }} type="number" />
                                                </div>
                                            </div>

                                            <div className="item_btn_form">
                                                <div className="modalformcontrols">
                                                    <Button type="submit">{t("submit")}</Button>
                                                </div>
                                                <div className="modalformcontrols">
                                                    <Button onClick={() => setShow(false)}>{t("close")}</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}
                </DashboardLayout>
                
                {/* Modal Thêm đại lý */}
                <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)} maxWidth="xs" fullWidth>
                    <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>Thêm đại lý</DialogTitle>
                    <form onSubmit={handleSubmit}>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField
                                    placeholder="* Tên đăng nhập"
                                    name="username"
                                    required
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    placeholder="* Mật khẩu"
                                    name="password"
                                    type="password"
                                    required
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    placeholder="Họ và tên"
                                    name="name"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    placeholder="Số điện thoại"
                                    name="sdt"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 2 }}>
                            <Button variant="outlined" color="inherit" onClick={() => setOpenAddModal(false)}>Hủy bỏ</Button>
                            <Button type="submit" variant="contained" color="error">Thêm mới</Button>
                        </DialogActions>
                    </form>
                </Dialog>

                {/* Modal Cập nhật đại lý */}
                <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)} maxWidth="xs" fullWidth>
                    <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>Sửa thông tin: {editUser?.username}</DialogTitle>
                    <form onSubmit={handleUpdateUser}>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField
                                    label="Họ và tên"
                                    name="name"
                                    value={editData.name}
                                    onChange={(e) => setEditData({...editData, name: e.target.value})}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Số điện thoại"
                                    name="sdt"
                                    value={editData.sdt}
                                    onChange={(e) => setEditData({...editData, sdt: e.target.value})}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Mật khẩu đăng nhập (nhập để đổi mới)"
                                    name="password"
                                    value={editData.password}
                                    onChange={(e) => setEditData({...editData, password: e.target.value})}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Mật khẩu rút tiền (nhập để đổi mới)"
                                    name="paypwd"
                                    value={editData.paypwd}
                                    onChange={(e) => setEditData({...editData, paypwd: e.target.value})}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 2 }}>
                            <Button variant="outlined" color="inherit" onClick={() => setOpenEditModal(false)}>Hủy bỏ</Button>
                            <Button type="submit" variant="contained" color="info">Cập nhật</Button>
                        </DialogActions>
                    </form>
                </Dialog>

            </ThemeProvider>
        </>
    );
}
export default AllEmployee;
